export const containerCss = "c1kru1xy";
export const contentCss = "c1e7r11c";
export const priceCss = "p1pxtytg";
export const registerLinkCss = "r1jdvtfi";

require("./index.style.linaria.module.css");